$(document).ready(function() {
    // Emoji strip utility — strips emoji characters from a string
    function stripEmojis(str) {
        return str.replace(/[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{FE00}-\u{FE0F}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{200D}\u{20E3}\u{E0020}-\u{E007F}]/gu, '');
    }

    // Global emoji stripping on all poster text inputs
    $(document).on('input', '.bp-name-input, .bp-place-input, .bp-custom-text-input, #bp-photo-heading, #bp-photo-subheading, #bp-star-text1, #bp-star-text2', function() {
        let cleaned = stripEmojis($(this).val());
        if (cleaned !== $(this).val()) {
            $(this).val(cleaned);
        }
    });

    function getStringDate(date, format) {
        return format.replace('[day]', parseInt(date[0])).replace('[day_formatted]', date[0]).replace('[month]', date[1]).replace('[year]', date[2])
    }

    // Compute combined bp-units value from the two independent unit inputs
    function updateCombinedUnits() {
        let lengthUnit = $('.bp-length-unit').val();
        let weightUnit = $('.bp-weight-unit').val();
        if (lengthUnit === weightUnit) {
            $('.bp-units').val(lengthUnit);
        } else {
            $('.bp-units').val('mixed');
        }
    }

    // --- LENGTH UNIT handler ---
    $('.bp-length-unit-radio').on('change', function(){
        let val = $(this).val();
        $('.bp-length-unit').val(val);
        $('.bp-length-unit').change();
    });

    $('.bp-length-unit').on('change', function(){
        let val = $(this).val();
        $(`.bp-length-unit-radio[value=${val}]`).each(function () {$(this).prop('checked', true)});

        if(val == 'imperial') {
            $('.bp-birth-length-selector').each(function() {
                let selected_val = $(this).find('option:selected').val();
                let closest_centimetres = 50.8; //default corresponding to 51cm (equal to 20 inches)
                for (var i = 5.9; i < 24.05; i=i+0.05) {
                    let rounded_index = (Math.round(i*20)/20);
                    let len = (Math.round((rounded_index*2.54)*2)/2).toString()
                    if (len == selected_val) {
                        closest_centimetres = Math.round((rounded_index*2.54)*1000)/1000
                    }
                }

                $(this).empty();
                for (var i = 5.9; i < 24.05; i=i+0.05) {
                    let rounded_index = (Math.round(i*20)/20);
                    $(this).append($('<option>', {
                        value: `${(Math.round((rounded_index*2.54)*1000)/1000)}`,
                        "data-length": rounded_index,
                        text: `${rounded_index} ${$('.bp-birth-length-selector').attr('data-imperial')}`
                    }));
                }
                $(this).append($('<option>', {
                    value: `51.0`,
                    "data-length": 'no_length',
                    text: `${$('.bp-birth-length-selector').attr('data-no-length-translation')}`
                }));

                if($(this).find(`option[value="${selected_val}"]`).length) {
                    $(this).find(`option[value="${selected_val}"]`).first().prop("selected", true);
                }
                else if($(this).find(`option[value="${closest_centimetres}"]`).length) {
                    $(this).find(`option[value="${closest_centimetres}"]`).first().prop("selected", true);
                }

                $(this).change();
            });
        }
        else {
            $('.bp-birth-length-selector').each(function() {
                let selected_val = $(this).find('option:selected').val();
                let centimetres = parseFloat(selected_val);
                let rounded_centimetres = (Math.round(centimetres*2)/2).toString();

                $(this).empty();
                for (var i = 15; i < 61.5; i=i+0.5) {
                    $(this).append($('<option>', {
                        value: `${i}`,
                        "data-length": i,
                        text: `${i} ${$('.bp-birth-length-selector').attr('data-metrics')}`
                    }));
                }
                $(this).append($('<option>', {
                    value: `51.0`,
                    "data-length": 'no_length',
                    text: `${$('.bp-birth-length-selector').attr('data-no-length-translation')}`
                }));

                if($(this).find(`option[value="${selected_val}"]`).length) {
                    $(this).find(`option[value="${selected_val}"]`).first().prop("selected", true);
                }
                else if($(this).find(`option[value="${rounded_centimetres}"]`).length) {
                    $(this).find(`option[value="${rounded_centimetres}"]`).first().prop("selected", true);
                }

                $(this).change();
            });
        }
        updateCombinedUnits();
    });

    // --- WEIGHT UNIT handler ---
    $('.bp-weight-unit-radio').on('change', function(){
        let val = $(this).val();
        $('.bp-weight-unit').val(val);
        $('.bp-weight-unit').change();
    });

    $('.bp-weight-unit').on('change', function(){
        let val = $(this).val();
        $(`.bp-weight-unit-radio[value=${val}]`).each(function () {$(this).prop('checked', true)});

        if(val == 'imperial') {
            $('.metric-weight').hide();
            $('.imperial-weight').show();
            $('.bp-weight-input').val('');
            $('.bp-weight-input').change();
            $('.bp-weight-input').removeAttr('required', '');
            $('.bp-pounds-input').attr('required', '');
        }
        else {
            $('.metric-weight').show();
            $('.imperial-weight').hide();
            $('.bp-pounds-input').val('');
            $('.bp-ounces-input').val('');
            $('.bp-pounds-input').change();
            $('.bp-ounces-input').change();
            $('.bp-weight-input').attr('required', '');
            $('.bp-pounds-input').removeAttr('required', '');
        }
        updateCombinedUnits();
    });

    // --- Backward compat: handle old .bp-units changes (e.g. from local storage restore) ---
    $('.bp-units').on('change', function(){
        let val = $(this).val();
        if(val === 'mixed') return;
        // When the combined value is set (e.g. from local storage), sync both sub-units
        if($('.bp-length-unit').val() !== val) {
            $('.bp-length-unit').val(val);
            $('.bp-length-unit').change();
        }
        if($('.bp-weight-unit').val() !== val) {
            $('.bp-weight-unit').val(val);
            $('.bp-weight-unit').change();
        }
    });
    
    $('.bp-name-input').on('input change', function(){
        let name = $(this).val();
        let index = $(this).attr('data-index');
        $(this).val(name.toUpperCase());
        $(`.bp-birth-name[data-index="${index}"]`).text(`${(index == '1' || name.length == 0 || no_of_babies > 2 ) ? '' : ' & '}${name.toUpperCase()}`);
        
        let max_width = $('.bp-poster-info').width() * 0.82;
        let headline = $('.bp-poster-headline');
        if(no_of_babies > 2) {
            max_width = $(`.bp-poster-info[data-index="${index}"]`).width() * 0.82;
            headline = $(`.bp-poster-info[data-index="${index}"] .bp-poster-headline`);
        }

        let current_width = headline.width()
        if(current_width > max_width) {
            let scale = max_width / current_width;
            headline.css('transform', 'scale(' + scale + ')');
        }
        else {
            headline.css('transform', 'scale(1)');
        }
    });

    $('.bp-scale-checkbox').on('change', function(){
        let scale_text = this.checked;
        if(no_of_babies < 3) {
            $('.bp-scale-checkbox-value').val( $('.bp-scale-checkbox-value').attr(`data-${scale_text}`));
            $('.bp-scale-checkbox-value').change();
            if(scale_text)
                $('.bp-scale-text').show();
            else
                $('.bp-scale-text').hide(); 
        }
        else {
            let index = $(this).attr('data-index');
            $(`.bp-scale-checkbox-value[data-index="${index}"]`).val( $(`.bp-scale-checkbox-value[data-index="${index}"]`).attr(`data-${scale_text}`));
            $(`.bp-scale-checkbox-value[data-index="${index}"]`).change();
            if(scale_text)
                $(`.bp-scale-text[data-index="${index}"]`).show();
            else
                $(`.bp-scale-text[data-index="${index}"]`).hide(); 
        }
    });

    $('.bp-scale-checkbox-value').on('change', function(){
        if($(this).val() == $(this).attr(`data-true`)) {
            if( no_of_babies < 3) {
                $('.bp-scale-checkbox').each(function () {$(this).prop('checked', true)});
                $('.bp-scale-text').show();
            }
            else {
                let index = $(this).attr('data-index');
                $(`.bp-scale-checkbox[data-index="${index}"]`).each(function () {$(this).prop('checked', true)});
                $(`.bp-scale-text[data-index="${index}"]`).show();
            }
        }
        else {
            if( no_of_babies < 3) {
                $('.bp-scale-checkbox').each(function () {$(this).prop('checked', false)});
                $('.bp-scale-text').hide();
            }
            else {
                let index = $(this).attr('data-index');
                $(`.bp-scale-checkbox[data-index="${index}"]`).each(function () {$(this).prop('checked', false)});
                $(`.bp-scale-text[data-index="${index}"]`).hide();
            }
        }
    });

    $('.bp-birth-length-selector').on('change', function(){
        let val = $(this).find(":selected").attr('data-length'); //this could be inches or something else depending upon requirement
        let length = $(this).val(); //this will always be centimetres so calculation can be done in centimetres
        let index = $(this).attr('data-index');
        let units_value = $('.bp-length-unit').val()
        let individual_metric = $(this).find(":selected").attr(`data-item-${units_value}`);
        let unit = $(this).attr(`data-${units_value}`);
        if(individual_metric)
            unit = individual_metric
        let size_factor = 58.45;
        if(no_of_babies == 2) {
            size_factor = 61;
        }
        if(no_of_babies == 3) {
            size_factor = 58;
        }
        if(no_of_babies == 4) {
            size_factor = 59.8;
        }
        let illustration_height = (parseFloat(length)/size_factor)*100;
        let max_illustration_height = 0;
        $('.bp-birth-length-selector').each(function () {
            let item_val = $(this).val();
            let current_height = ((parseFloat(item_val)+0.5)/size_factor)*100;
            if(current_height > max_illustration_height) {
                max_illustration_height = current_height
            }
        })
        if(max_illustration_height < 100) {
            max_illustration_height = 100;
        }

        if($('.birthposter-template').hasClass('horizontal-poster')) {
            // if(illustration_height > 100) {
            //     $(`.bp-preview-illustration`).css('width', `${illustration_height}%`)
            //     $(`.bp-preview-illustration`).css('transform', `translateX(-${(illustration_height - 100)/2}%)`)
            //     $(`.bp-preview-illustration img[data-index="${index}"]`).css('width', `100%`)
            //     $(`.bp-preview-illustration img[data-index="${index}`).css('height', `auto`)
            // }
            // else {
                // $(`.bp-preview-illustration`).css('width', `100%`)
                // $(`.bp-preview-illustration`).css('transform', `translateX(0%)`)
                $(`.bp-preview-illustration-bg`).css('width', `${max_illustration_height}%`)
                $(`.bp-preview-illustration-bg`).css('height', "100%")
                // $(`.bp-preview-illustration`).css('transform', `translateX(-${(max_illustration_height - 100)/2}%)`)
                $(`.bp-preview-illustration img[data-index="${index}"]`).css('width', `${illustration_height}%`)
                $(`.bp-preview-illustration img[data-index="${index}`).css('height', `auto`)
            // }
        }
        else {
            // if(illustration_height > 100) {
            //     $(`.bp-preview-illustration`).css('height', `${illustration_height}%`)
            //     $(`.bp-preview-illustration`).css('transform', `translateY(-${(illustration_height - 100)/2}%)`)
            //     $(`.bp-preview-illustration img[data-index="${index}`).css('height', `100%`)
            //     $(`.bp-preview-illustration img[data-index="${index}`).css('width', `auto`)
            // }
            // else {
                // $(`.bp-preview-illustration`).css('height', `100%`)
                // $(`.bp-preview-illustration`).css('transform', `translateY(0%)`)
                $(`.bp-preview-illustration-bg`).css('height', `${max_illustration_height}%`)
                $(`.bp-preview-illustration-bg`).css('width', "100%")
                // $(`.bp-preview-illustration`).css('transform', `translateY(-${(max_illustration_height - 100)/2}%)`)
                $(`.bp-preview-illustration img[data-index="${index}`).css('height', `${illustration_height}%`)
                $(`.bp-preview-illustration img[data-index="${index}`).css('width', `auto`)
            // }
        }
        if(val == 'no_length') {
            $(`.bp-length[data-index="${index}`).text(``);
            $(`#length-current-${index}`).val("");
        }
        else {
            $(`.bp-length[data-index="${index}`).text(`${val} ${unit}`);
            $(`#length-current-${index}`).val(`${val} ${unit}`);
        }
        setTimeout(() => {
            for (let i = 1; i < no_of_babies; i++) {
                $(`.bp-preview-illustration img[data-index="${i}`).css('margin-right', `0px`)
            }
            let overflow = $('.bp-preview-illustration')[0].scrollWidth - $('.bp-preview-illustration').width();
            let set_margin = overflow*2/(no_of_babies-1); //margin will be divided for each illustration except last
            if (set_margin > 0) {
                for (let i = 1; i < no_of_babies; i++) {
                    $(`.bp-preview-illustration img[data-index="${i}`).css('margin-right', `-${set_margin}px`)
                }
            }
        }, 200);
    });

    $('.bp-weight-input').on('input change', function(){
        let weight = $(this).val();
        let index = $(this).attr('data-index');
        let unit = $(this).attr('data-unit');
        let max = $(this).attr('max');
        let min = $(this).attr('min');
        let prev = $(this).attr('data-prev');

        if(parseFloat(weight) > parseFloat(max)) {
            $(this).val(prev)
        } 

        $(this).attr('data-prev', $(this).val())

        weight = $(this).val();
        if(parseFloat(weight) >= parseFloat(min)){
            $(`.bp-weight[data-index="${index}"] .metric-weight`).text(`${weight} ${unit}`);
            $(`#weight-metric-current-${index}`).val(`${weight} ${unit}`);
        } 
        else {
            $(`.bp-weight[data-index="${index}"] .metric-weight`).text(``);
            $(`#weight-metric-current-${index}`).val(``);
        }
        // for safari to update dom :before pseudo class
        $(`.bp-weight[data-index="${index}"]`).css('visibility', 'hidden');
        $(`.bp-weight[data-index="${index}"]`).css('visibility', '');
    });

    $('.bp-pounds-input').on('input change', function(){
        let weight = $(this).val();
        let index = $(this).attr('data-index');
        let max = $(this).attr('max');
        let min = $(this).attr('min');
        let prev = $(this).attr('data-prev');

        if(parseFloat(weight) > parseFloat(max)) {
            $(this).val(prev)
        } 

        $(this).attr('data-prev', $(this).val())

        weight = $(this).val();

        if(parseFloat(weight) == 1) {
            $('.bp-pounds-unit').text('POUND');
        }
        else {
            $('.bp-pounds-unit').text('POUNDS');
        }
        
        let ounces = $(`.bp-ounces-input[data-index="${index}"]`).val();
        let ounces_min = $(`.bp-ounces-input[data-index="${index}"]`).attr('min');

        if(parseFloat(weight) >= parseFloat(min)){
            if(parseFloat(ounces) >= parseFloat(ounces_min)) {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${weight} ${(parseFloat(weight) == 1) ? 'POUND': 'POUNDS'} ${ounces} ${(parseFloat(ounces) == 1) ? 'OUNCE': 'OUNCES'}`)
                $(`#weight-imperial-current-${index}`).val(`${weight} ${(parseFloat(weight) == 1) ? 'POUND': 'POUNDS'} ${ounces} ${(parseFloat(ounces) == 1) ? 'OUNCE': 'OUNCES'}`)
            }
            else {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${weight} ${(parseFloat(weight) == 1) ? 'POUND': 'POUNDS'}`)
                $(`#weight-imperial-current-${index}`).val(`${weight} ${(parseFloat(weight) == 1) ? 'POUND': 'POUNDS'}`)
            }
        } 
        else {
            if(parseFloat(ounces) >= parseFloat(ounces_min)) {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${ounces} ${(parseFloat(ounces) == 1) ? 'OUNCE': 'OUNCES'}`)
                $(`#weight-imperial-current-${index}`).val(`${ounces} ${(parseFloat(ounces) == 1) ? 'OUNCE': 'OUNCES'}`)
            }
            else {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(``)
                $(`#weight-imperial-current-${index}`).val(``)
            }
        }
        // for safari to update dom :before pseudo class
        $(`.bp-weight[data-index="${index}"]`).css('visibility', 'hidden');
        $(`.bp-weight[data-index="${index}"]`).css('visibility', '');
    });

    $('.bp-ounces-input').on('input change', function(){
        let weight = $(this).val();
        let index = $(this).attr('data-index');
        let max = $(this).attr('max');
        let min = $(this).attr('min');
        let prev = $(this).attr('data-prev');

        if(parseFloat(weight) > parseFloat(max)) {
            $(this).val(prev)
        } 

        $(this).attr('data-prev', $(this).val())

        weight = $(this).val();

        if(parseFloat(weight) == 1) {
            $('.bp-ounces-unit').text('OUNCE');
        }
        else {
            $('.bp-ounces-unit').text('OUNCES');
        }
        
        let pounds = $(`.bp-pounds-input[data-index="${index}"]`).val();
        let pounds_min = $(`.bp-pounds-input[data-index="${index}"]`).attr('min');

        if(parseFloat(weight) >= parseFloat(min)){
            if(parseFloat(pounds) >= parseFloat(pounds_min)) {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${pounds} ${(parseFloat(pounds) == 1) ? 'POUND': 'POUNDS'} ${weight} ${(parseFloat(weight) == 1) ? 'OUNCE': 'OUNCES'}`)
                $(`#weight-imperial-current-${index}`).val(`${pounds} ${(parseFloat(pounds) == 1) ? 'POUND': 'POUNDS'} ${weight} ${(parseFloat(weight) == 1) ? 'OUNCE': 'OUNCES'}`)
            }
            else {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${weight} ${(parseFloat(weight) == 1) ? 'OUNCE': 'OUNCES'}`)
                $(`#weight-imperial-current-${index}`).val(`${weight} ${(parseFloat(weight) == 1) ? 'OUNCE': 'OUNCES'}`)
            }
        } 
        else {
            if(parseFloat(pounds) >= parseFloat(pounds_min)) {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(`${pounds} ${(parseFloat(pounds) == 1) ? 'POUND': 'POUNDS'}`)
                $(`#weight-imperial-current-${index}`).val(`${pounds} ${(parseFloat(pounds) == 1) ? 'POUND': 'POUNDS'}`)
            }
            else {
                $(`.bp-weight[data-index="${index}"] .imperial-weight`).text(``)
                $(`#weight-imperial-current-${index}`).val(``)
            }
        }
        // for safari to update dom :before pseudo class
        $(`.bp-weight[data-index="${index}"]`).css('visibility', 'hidden');
        $(`.bp-weight[data-index="${index}"]`).css('visibility', '');
    });

    $('.bp-birth-day-selector').on('change', function(){
        let day = $(this).val();
        day = parseInt(day).toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        let index = $(this).attr('data-index');
        let date = $(`.birth-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[0] = day;
        date = date.join("-");
        $(`.birth-date[data-index="${index}"]`).val(date);
        $(`.birth-date[data-index="${index}"]`).change();
    });

    $('.bp-birth-month-selector').on('change', function(){
        let month = $(this).find(":selected").attr('data-month');
        let index = $(this).attr('data-index');

        let current_month_days = month_day_object[`${parseInt(month)}`]
        let selected_day = parseInt($(`.bp-birth-day-selector[data-index="${index}"] option:selected`).val());
        let date_format = $(`.birth-date[data-index="${index}"]`).attr("data-format");
        let digits = 1;
        if(date_format.includes("day_formatted")) {
            digits = 2;
        }

        $(`.bp-birth-day-selector[data-index="${index}"]`).empty();
        for (var i = 1; i <= current_month_days; i++) {
            let formatted_number = i.toLocaleString('en-US', { minimumIntegerDigits: digits, useGrouping: false });
            $(`.bp-birth-day-selector[data-index="${index}"]`).append($('<option>', {
                value: `${i}`,
                text: `${formatted_number}`
            }));
        }
        
        if($(`.bp-birth-day-selector[data-index="${index}"] option[value="${selected_day}"]`).length) {
            $(`.bp-birth-day-selector[data-index="${index}"]`).val(selected_day);
        }
        else {
            $(`.bp-birth-day-selector[data-index="${index}"]`).val(1);
        }
        // Set the month in birth-date before triggering day change,
        // so the day handler cascade picks up the correct month
        let date = $(`.birth-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[1] = month;
        date = date.join("-");
        $(`.birth-date[data-index="${index}"]`).val(date);

        // Trigger day change which cascades to birth-date change (single fire)
        $(`.bp-birth-day-selector[data-index="${index}"]`).change();
    });

    $('.bp-birth-year-selector').on('change', function(){
        let year = $(this).val();
        let index = $(this).attr('data-index');
        let date = $(`.birth-date[data-index="${index}"]`).val();
        date = date.split("-");
        date[2] = year;
        date = date.join("-");
        $(`.birth-date[data-index="${index}"]`).val(date);
        $(`.birth-date[data-index="${index}"]`).change();
    });

    $('.birth-date').on('change', function(){
        let date = $(this).val();
        let index = $(this).attr('data-index');
        let format = $(this).attr('data-format');
        date = date.split("-");

        $(`.bp-birth-day-selector[data-index="${index}"]`).val(parseInt(date[0]))
        $(`.bp-birth-month-selector[data-index="${index}"]`).val($(`.bp-birth-month-selector[data-index="${index}"]`).find(`[data-month=${date[1]}]`).val());
        $(`.bp-birth-year-selector[data-index="${index}"]`).val(date[2])

        date[1] = $(`.bp-birth-month-selector[data-index="${index}"]`).find(`[data-month=${date[1]}]`).val().toUpperCase();
        date = getStringDate(date, format);
        $(`.bp-date[data-index="${index}"]`).text(`${date}`)
        $(`#date-current-${index}`).val(`${date}`)
    });

    $('.bp-hours-input').on('input change', function(){
        let hours = $(this).val();
        let max = $(this).attr('max');
        let index = $(this).attr('data-index');
        let ext = $(`.birth-time[data-index="${index}"]`).attr("data-ext").replaceAll(" ", "" ).replaceAll(".", "" );

        let prev = $(this).attr('data-prev');
        
        if(parseFloat(hours) > parseFloat(max)) {
            $(this).val(prev)
        } 

        $(this).attr('data-prev', $(this).val())
        
        // hours = $(this).val();
        // hours_int = parseInt(hours);
        // if(hours_int) {
        //     let formatted_number = hours_int.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        //     $(this).val(formatted_number)
        // }

        hours = $(this).val();
        if(hours.length > 1) {
            $(`.bp-minutes-input[data-index="${index}"]`).focus();
        }

        hours = $(this).val();
        let time = $(`.birth-time[data-index="${index}"]`).val();
        time = time.replace("AM", "").replace("PM", "");
        if(time){
            time = time.split(":")
            time[0] = hours
            time = time.join(":")
            $(`.birth-time[data-index="${index}"]`).val(time + ext);
            $(`.birth-time[data-index="${index}"]`).change();
        }
        else{
            $(`.birth-time[data-index="${index}"]`).val(`${hours}:`);
            $(`.birth-time[data-index="${index}"]`).change();
        }
    });

    $('.bp-minutes-input').on('input change', function(){
        let minutes = $(this).val();
        let max = $(this).attr('max');
        let index = $(this).attr('data-index');
        let ext = $(`.birth-time[data-index="${index}"]`).attr("data-ext").replaceAll(" ", "" ).replaceAll(".", "" );

        let prev = $(this).attr('data-prev');

        if(parseFloat(minutes) > parseFloat(max)) {
            $(this).val(prev)
        } 
        
        $(this).attr('data-prev', $(this).val())

        // minutes = $(this).val();
        // minutes_int = parseInt(minutes);
        // if(minutes_int) {
        //     let formatted_number = minutes_int.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false });
        //     $(this).val(formatted_number)
        // }

        minutes = $(this).val();
        let time = $(`.birth-time[data-index="${index}"]`).val();
        time = time.replace("AM", "").replace("PM", "");
        if(time){
            time = time.split(":")
            time[1] = minutes
            time = time.join(":")
            $(`.birth-time[data-index="${index}"]`).val(time + ext);
            $(`.birth-time[data-index="${index}"]`).change();
        }
        else{
            $(`.birth-time[data-index="${index}"]`).val(`:${minutes}`);
            $(`.birth-time[data-index="${index}"]`).change();
        }
    });

    $('.bp-time-unit').on('change', function(){
        let val = $(this).val();
        let index = $(this).attr('data-index');

        let hrs = parseInt($(`.bp-hours-input[data-index="${index}"]`).val())
        if(val) {
            $(`.bp-hours-input[data-index="${index}"]`).attr("max", 12);
            $(`.birth-time[data-index="${index}"]`).attr("data-ext", ` ${val}`)
            if(hrs > 12) {
                $(`.bp-hours-input[data-index="${index}"]`).val(hrs - 12);
            }
        }
        else {
            $(`.birth-time[data-index="${index}"]`).attr("data-ext", ``)
            $(`.bp-hours-input[data-index="${index}"]`).attr("max", 23);
        }
        $(`.bp-hours-input[data-index="${index}"]`).change()
    });

    $('.birth-time').on('change', function(){
        let time = $(this).val();
        let only_time = time.replace("AM", "").replace("PM", "");
        let ext = "";
        let index = $(this).attr('data-index');
        if(time.includes("AM")) {
            $(`.bp-hours-input[data-index="${index}"]`).attr("max", 12);
            $(`.bp-time-unit[data-index="${index}"]`).val("A.M.");
            ext = " A.M.";
        }
        else if (time.includes("PM")) {
            $(`.bp-hours-input[data-index="${index}"]`).attr("max", 12);
            $(`.bp-time-unit[data-index="${index}"]`).val("P.M.");
            ext = " P.M."
        }

        $(this).attr("data-ext", ext);

        let time_arr = only_time.split(":");

        if(time_arr[0].length > 0 && time_arr[1].length > 0 ) {
            $(`.bp-hours-input[data-index="${index}"]`).val(time_arr[0]);
            $(`.bp-minutes-input[data-index="${index}"]`).val(time_arr[1]);
            $(`.bp-time[data-index="${index}"]`).text(only_time + ext);
            $(`#time-current-${index}`).val(only_time + ext);
        }
        else {
            if(time_arr[0].length == 0){
                $(`.bp-hours-input[data-index="${index}"]`).val('');
            }
            if(time_arr[1].length == 0){
                $(`.bp-minutes-input[data-index="${index}"]`).val('');
            }
            $(`.bp-time[data-index="${index}"]`).text('');
            $(`#time-current-${index}`).val('');
        }
    });

    $('.bp-place-input').on('input change', function(){
        let place = $(this).val();
        let index = $(this).attr('data-index');

        $(this).val(place.toUpperCase());
        if(place.length) {
            $(`.bp-place[data-index="${index}"]`).text(`${place.toUpperCase()}`);
            $(`#place-current-${index}`).val(`${place.toUpperCase()}`);
        }
        else {
            $(`.bp-place[data-index="${index}"]`).text(``);
            $(`#place-current-${index}`).val(``);
        }
    });

    $('.bp-illustration-value').on('change', function(){
        let illustration = $(this).val();
        let index = $(this).attr('data-index');
        if (parseInt(index) > 1)
        $(`.bp-variant-options-radio[data-index="${index}"][data-value="${illustration}"]`).click();
    });

    // --- Custom Text Toggle (Feature 1) ---
    function assembleSubheading(index) {
        let length = ($(`#length-current-${index}`).length) ? $(`#length-current-${index}`).val() : '';
        let metric_weight = ($(`#weight-metric-current-${index}`).length) ? $(`#weight-metric-current-${index}`).val() : '';
        let imperial = ($(`#weight-imperial-current-${index}`).length) ? $(`#weight-imperial-current-${index}`).val() : '';
        let date = ($(`#date-current-${index}`).length) ? $(`#date-current-${index}`).val() : '';
        let time = ($(`#time-current-${index}`).length) ? $(`#time-current-${index}`).val() : '';
        let place = ($(`#place-current-${index}`).length) ? $(`#place-current-${index}`).val() : '';

        return [length, metric_weight, imperial,
            [date, time].filter(str => str !== "").join(' '),
            place
        ].filter(str => str !== "").join(' / ').trim();
    }

    function updateSubheadingPreview(index, text) {
        // Update BOTH the visible poster and the hidden-preview (used for cart screenshot)
        var containers = ['.birthposter-template', '.hidden-preview'];
        containers.forEach(function(container) {
            if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
                let el = $(`${container} .bp-poster-info[data-index="${index}"] .bp-poster-subheading`);
                el.html(`<span class="bp-custom-subheading">${text}</span>`);
            } else {
                let subheadings = $(`${container} .bp-poster-subheading`);
                let el = subheadings.eq(index - 1);
                if(el.length) {
                    el.html(`<span class="bp-custom-subheading">${text}</span>`);
                }
            }
        });

        // Scale subheading if too wide (visible poster only)
        let parentInfo;
        if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
            parentInfo = $(`.birthposter-template .bp-poster-info[data-index="${index}"]`);
        } else {
            parentInfo = $('.birthposter-template .bp-poster-info');
        }
        let max_width = parentInfo.width() * 0.82;
        let subEl;
        if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
            subEl = $(`.birthposter-template .bp-poster-info[data-index="${index}"] .bp-poster-subheading`);
        } else {
            subEl = $('.birthposter-template .bp-poster-subheading').eq(index - 1);
        }
        let current_width = subEl.width();
        if(current_width > max_width) {
            let scale = max_width / current_width;
            subEl.css('transform', 'scale(' + scale + ')');
        } else {
            subEl.css('transform', 'scale(1)');
        }
    }

    // Store original subheading HTML for each baby to restore when toggling back
    let originalSubheadingHTML = {};
    let originalHiddenSubheadingHTML = {};

    $('.bp-custom-text-toggle').on('click', function(){
        let index = $(this).attr('data-index');
        let container = $(`.bp-custom-text-container[data-index="${index}"]`);
        let textarea = $(`#bp-custom-text-${index}`);
        let flag = $(`#bp-custom-text-flag-${index}`);
        let isActive = container.is(':visible');

        if(!isActive) {
            // Activate custom text mode — only pre-fill if textarea is empty (preserves restored value)
            if(!textarea.val().trim()) {
                let currentSubheading = assembleSubheading(index);
                textarea.val(currentSubheading.toUpperCase());
            }
            container.show();
            flag.val('true');

            // Save original subheading HTML (both visible and hidden preview)
            if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
                originalSubheadingHTML[index] = $(`.birthposter-template .bp-poster-info[data-index="${index}"] .bp-poster-subheading`).html();
                originalHiddenSubheadingHTML[index] = $(`.hidden-preview .bp-poster-info[data-index="${index}"] .bp-poster-subheading`).html();
            } else {
                originalSubheadingHTML[index] = $('.birthposter-template .bp-poster-subheading').eq(parseInt(index) - 1).html();
                originalHiddenSubheadingHTML[index] = $('.hidden-preview .bp-poster-subheading').eq(parseInt(index) - 1).html();
            }

            // Update the preview with current text
            updateSubheadingPreview(index, textarea.val());

            // Dim structured fields
            $(this).closest('.bp-sidebar-item-content').find('.bp-sidebar-object').not('.bp-custom-text-section').addClass('bp-sidebar-object-dimmed');

            // Toggle button labels
            $(this).find('.bp-custom-text-toggle-label').hide();
            $(this).find('.bp-custom-text-toggle-back').show();
        } else {
            // Deactivate custom text mode
            container.hide();
            textarea.val('');
            flag.val('');

            // Un-dim structured fields first (before triggering changes)
            $(this).closest('.bp-sidebar-item-content').find('.bp-sidebar-object').removeClass('bp-sidebar-object-dimmed');

            // Toggle button labels
            $(this).find('.bp-custom-text-toggle-label').show();
            $(this).find('.bp-custom-text-toggle-back').hide();

            // Restore original subheading HTML (both visible and hidden preview)
            if(originalSubheadingHTML[index]) {
                if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
                    $(`.birthposter-template .bp-poster-info[data-index="${index}"] .bp-poster-subheading`).html(originalSubheadingHTML[index]);
                    $(`.hidden-preview .bp-poster-info[data-index="${index}"] .bp-poster-subheading`).html(originalHiddenSubheadingHTML[index]);
                } else {
                    $('.birthposter-template .bp-poster-subheading').eq(parseInt(index) - 1).html(originalSubheadingHTML[index]);
                    $('.hidden-preview .bp-poster-subheading').eq(parseInt(index) - 1).html(originalHiddenSubheadingHTML[index]);
                }
                let subEl;
                if(typeof no_of_babies !== 'undefined' && no_of_babies >= 3) {
                    subEl = $(`.birthposter-template .bp-poster-info[data-index="${index}"] .bp-poster-subheading`);
                } else {
                    subEl = $('.birthposter-template .bp-poster-subheading').eq(parseInt(index) - 1);
                }
                subEl.css('transform', 'scale(1)');
            }

            // Re-trigger field updates to refresh preview
            $(`.bp-birth-length-selector[data-index="${index}"]`).change();
            $(`.bp-weight-input[data-index="${index}"]`).change();
            $(`.bp-pounds-input[data-index="${index}"]`).change();
            $(`.bp-ounces-input[data-index="${index}"]`).change();
            $(`.birth-date[data-index="${index}"]`).change();
            $(`.birth-time[data-index="${index}"]`).change();
            $(`.bp-place-input[data-index="${index}"]`).change();
        }
    });

    // Real-time preview update when typing in custom text textarea
    $('.bp-custom-text-input').on('input', function(){
        let index = $(this).attr('data-index');
        let text = $(this).val().toUpperCase();
        let start = this.selectionStart;
        let end = this.selectionEnd;
        $(this).val(text);
        this.setSelectionRange(start, end);
        updateSubheadingPreview(index, text);
    });
});